import { Action } from 'redux';

import { NewPublishedDatasourceFromDatasource } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface NewPublishedDatasourceFromDatasourceAction extends Action {
  datasource: IContentInfo;
  projectId?: string;
}

export function newPublishedDatasourceFromDatasource(datasource: IContentInfo, projectId?: string): NewPublishedDatasourceFromDatasourceAction {
  return {
    type: NewPublishedDatasourceFromDatasource,
    datasource,
    projectId
  };
}

export const isNewPublishedDatasourceFromDatasourceAction = isActionFactory<NewPublishedDatasourceFromDatasourceAction>(NewPublishedDatasourceFromDatasource);
